import { create } from './Create/Create.i18n.ja'
import { importFromCsv } from './Import/Import.i18n.ja'

export const idCards = {
  create,
  importFromCsv,
}
